import {useTranslation} from "react-i18next";

const {WhatsApp} = require("@mui/icons-material");
const React = require("react");

const CustomizationInfoBox = ({title, hook}) => {
    const {t, i18n} = useTranslation()

    return (<div className="card border-warning shadow-sm">
        <div className="card-body row align-items-start align-items-md-center">
            <div className="col-12 col-md-8 d-flex align-items-start gap-2">
                <span className="fs-4 text-warning">⚠️</span>
                <div>
                    <h5 className="mb-1">{title ? t(title) : t('setting.emission.custom.title')}
                    </h5>
                    <p className="mb-0 text-muted">
                        <span>{hook ? t(hook) : t('setting.emission.custom.hook')}</span>
                        <br/>
                        <span>{t('setting.emission.custom.cta')}</span>
                    </p>
                </div>
            </div>

            <div className="col-12 col-md-4 text-center text-md-end mt-3 mt-md-0">
                <a
                    href="https://wa.me/6282228886906?text=Hello%20Trucarbon,%20I%20need%20customized%20emission%20factors"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-success d-inline-flex align-items-center gap-2"
                >
                    <WhatsApp/>
                    {t('setting.emission.custom.button')}
                </a>
            </div>
        </div>
    </div>)
}

export default CustomizationInfoBox
